export const ELEMENTS = [
  { key: "earth", label: "Earth", emoji: "🌱", color: "bg-green-400", hint: "Body & environment" },
  { key: "water", label: "Water", emoji: "💧", color: "bg-blue-400", hint: "Emotions" },
  { key: "air", label: "Air", emoji: "🌬️", color: "bg-sky-300", hint: "Thoughts" },
  { key: "fire", label: "Fire", emoji: "🔥", color: "bg-orange-400", hint: "Spirit" },
];

export const DEFAULT_CYCLE_LENGTH = 28;

export const DEFAULT_CYCLE_STAGES = [
  { id: "winter", name: "Winter - Menstruation", length: DEFAULT_CYCLE_LENGTH / 4 },
  { id: "spring", name: "Spring - Follicular", length: DEFAULT_CYCLE_LENGTH / 4 },
  { id: "summer", name: "Summer - Ovulatory", length: DEFAULT_CYCLE_LENGTH / 4 },
  { id: "autumn", name: "Autumn - Luteal", length: DEFAULT_CYCLE_LENGTH / 4 },
];

export const EMPTY_ELEMENT_ENTRY = {
  text: "",
  action: "",
  redirect: false,
  cycleNote: "",
  rating: null,
};

export const DEFAULT_RATING_EMOJI_SET = ["😞", "🙁", "😐", "🙂", "😊"];

export const STORAGE_KEY = "elements_app_v1";
